module.exports = __webpack_public_path__ + "static/media/18.175d4510.mp3";